<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Next billing</template>

    <Sheet.Body>
      <UpcomingBillingDetailsBody :details="details" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import type { BillingPlanDetails } from '@/shared/graphql/legacy/generated'
import UpcomingBillingDetailsBody from './UpcomingBillingDetailsBody.vue'

defineProps<{
  details: BillingPlanDetails
}>()

const { close } = useSheet()
</script>
